import { Accordion, AccordionHeader, AccordionBody } from "@material-tailwind/react";
import { useState } from "react";
import RePeopleGHSAccordionBody from "./RePeopleGHSAccordionBody";

const GHSAccordion = () => {
  const [open, setOpen] = useState(1);

  const handleOpen = (openNumber: number) => setOpen(open === openNumber ? 0 : openNumber);

  const Icon = ({ id, open }: any) => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        strokeWidth={2}
        stroke="currentColor"
        className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
      >
        <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
      </svg>
    );
  };

  return (
    <div className="max-h-full max-w-full rounded-lg bg-white shadow-md">
      <h3 className="p-4 text-lg font-medium">Human Settlement Layer</h3>
      <div className="h-[0.5px] w-full bg-gray-300"></div>
      <div className="p-4 font-primary">
        {/* accordion view */}
        <Accordion placeholder={""} open={open === 1} icon={<Icon id={1} open={open} />}>
          <AccordionHeader
            placeholder={""}
            onClick={() => handleOpen(1)}
            className="text-md font-medium text-black"
          >
            <span className="font-primary">GHS</span>
          </AccordionHeader>
          <AccordionBody>
            <RePeopleGHSAccordionBody />
          </AccordionBody>
        </Accordion>
      </div>
    </div>
  );
};

export default GHSAccordion;
